export enum ELocales {
    en = 'en',
    uk = 'uk',
    es = 'es',
    default = 'uk'
}